import { ChangeDetectorRef, EventEmitter, Output, SimpleChanges } from "@angular/core";
import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { FormGroup, FormArray, FormBuilder, FormControl } from "@angular/forms";

import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from "@angular/material/dialog";
import { DevicePilomat } from "../model/devicePilomat";
import { Log } from "../util/log";
import { DeviceService } from "../service/device.service";
import { UserService } from "../service/user.service";
import { HeaderComponent } from "../navigation/header/header.component";
import { DateHelper } from "../util/dateHelper";
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { Overlay } from "@angular/cdk/overlay";
import { PilomatSystemInfo } from "../model/pilomatSystemInfo";
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-device-detail-editor',
  templateUrl: './device-detail-editor.component.html',
  styleUrls: ['./device-detail-editor.component.css']
})
export class DeviceDetailEditorComponent implements OnInit {

  @ViewChild("devicedetailsloader", { static: true }) loader;

  device: DevicePilomat;
  devicePhoneNumber: string = "";
  deviceReference: string = "Rif";
  deviceAddress: string = "";
  deviceCity: string = "";
  deviceCountry: string = "";
  deviceOrderConfirmation: string = "";
  deviceInstallationDate: Date;
  deviceRouterSerial: string = "";
  deviceSystemId: string = "";
  notes: string = "";

  // TODO
  // items: FormArray = new FormArray([]);

  initialCanBusEnabled: boolean;
  initialIoEthEnabled: boolean;
  initialLicencePlateEnabled: boolean;

  canBusEnabledStr: string;
  ioEthEnabledStr: string;
  licensePlateEnabledStr: string;
  badge1EnabledStr: string;
  badge2EnabledStr: string;

  pin1EnabledStr: string;
  pin2EnabledStr: string;

  phoneEnabledStr: string;
  remoteEnabledStr: string;

  appEnabledStr: string;

  watchdogEnabledStr : string;
  watchDogTimeSecValue : number;
  showWatchDogTimeSecValue : boolean;

  deviceModel: string;
  models: string[] = [];

  deviceDetailsForm = new FormGroup({
    reference: new FormControl(''),
    phoneNumber: new FormControl(''),
    orderConfirmation: new FormControl(''),
    installationDate: new FormControl(''),
    city: new FormControl(''),
    address: new FormControl(''),
    country: new FormControl(''),
    canBusEnabledRadio: new FormControl(''),
    ioEthEnabledRadio: new FormControl(''),
    licensePlateEnabledRadio: new FormControl(''),
    badge1EnabledRadio: new FormControl(''),
    badge2EnabledRadio: new FormControl(''),
    pin1EnabledRadio: new FormControl(''),
    pin2EnabledRadio: new FormControl(''),
    phoneEnabledStrRadio: new FormControl(''),
    remoteEnabledRadio: new FormControl(''),
    appEnabledRadio: new FormControl(''),
    watchdogEnabledRadio: new FormControl(''),
    watchDogTimeSecInput: new FormControl(''),
    deviceModelSelect: new FormControl(''),
    router: new FormControl(''),
    systemId: new FormControl(''),
    notes: new FormControl('')
  });


  constructor(
    public dialogRef: MatDialogRef<DeviceDetailEditorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private deviceService: DeviceService,
    private userService: UserService,
    private cdRef: ChangeDetectorRef,
    private formBuilder: FormBuilder,
    private overlay: Overlay,
  ) {
    Log.debug('Device details dialoge editor:   input data');
    Log.debug(data);

    this.device = data.device;
    if (this.device.canBusEnabled) {
      this.canBusEnabledStr = "true";
    } else {
      this.canBusEnabledStr = "false";
    }

    if (this.device.ioEthEnabled) {
      this.ioEthEnabledStr = "true";
    } else {
      this.ioEthEnabledStr = "false";
    }

    if (this.device.licensePlateEnabled) {
      this.licensePlateEnabledStr = "true";
    } else {
      this.licensePlateEnabledStr = "false";
    }

    if (this.device.badge1Enabled) {
      this.badge1EnabledStr = "true";
    } else {
      this.badge1EnabledStr = "false";
    }

    if (this.device.badge2Enabled) {
      this.badge2EnabledStr = "true";
    } else {
      this.badge2EnabledStr = "false";
    }

    if (this.device.pin1Enabled) {
      this.pin1EnabledStr = "true";
    } else {
      this.pin1EnabledStr = "false";
    }

    if (this.device.pin2Enabled) {
      this.pin2EnabledStr = "true";
    } else {
      this.pin2EnabledStr = "false";
    }

    if (this.device.phoneEnabled) {
      this.phoneEnabledStr = "true";
    } else {
      this.phoneEnabledStr = "false";
    }

    if (this.device.remoteEnabled) {
      this.remoteEnabledStr = "true";
    } else {
      this.remoteEnabledStr = "false";
    }

    if (this.device.appEnabled) {
      this.appEnabledStr = "true";
    } else {
      this.appEnabledStr = "false";
    }

    if (this.device.watchDogEnabled) {
      this.watchdogEnabledStr = "true";
      this.showWatchDogTimeSecValue = true;
    } else {
      this.watchdogEnabledStr = "false";
      this.showWatchDogTimeSecValue = false;
    }

    if (this.device.watchDogTimeSec) {
      this.watchDogTimeSecValue = this.device.watchDogTimeSec;
    } else {
      this.watchDogTimeSecValue = 0;
    }

    if (this.device.routerSerial) {
      this.deviceRouterSerial = this.device.routerSerial;
    }

    if (this.device.systemId) {
      this.deviceSystemId = this.device.systemId;
    }

    this.devicePhoneNumber = this.device.phoneNumber;

    this.initialCanBusEnabled = this.device.canBusEnabled;
    this.initialIoEthEnabled = this.device.ioEthEnabled;
    this.initialLicencePlateEnabled = this.device.licensePlateEnabled;

    this.deviceAddress = this.device.systemInfo.address;
    this.deviceCity = this.device.systemInfo.city;
    this.deviceCountry = this.device.systemInfo.country;
    this.deviceOrderConfirmation = this.device.orderConfirmation;

    this.deviceInstallationDate = new Date(this.device.bollardInstallationDate);
    this.deviceReference = this.device.systemInfo.reference;
    this.deviceModel = this.device.systemInfo.model;

    // TODO
    // this.notes = this.device.notes;
    Log.debug(this.device);

  }

  ngOnInit(): void {
      this.cdRef.detectChanges();
  }

  ngAfterViewInit() {

    setTimeout(() => {

      this.models = PilomatSystemInfo.MODELS;

      this.loader.hideLoading();

    });
  }

  ngOnChanges() {
    if (!this.showWatchDogTimeSecValue) {
      this.watchDogTimeSecValue = 0;
    }
  }

  inputControl(event) {
    if(this.watchDogTimeSecValue > 600){
      this.watchDogTimeSecValue = 600;
    } else if(this.watchDogTimeSecValue < 60){
      this.watchDogTimeSecValue = 60;
    }
  }

  enableTimeSetting(value){
    Log.debug("\n\nenableTimeSetting value: ");
    Log.debug(value);

    this.showWatchDogTimeSecValue = value;
    this.inputControl(null);

    this.cdRef.detectChanges();
  }


  closeDialog() {
    this.dialogRef.close();
  }

  public isAdmin(): boolean {
    return this.userService.isAdmin;
  }

  public isService(): boolean {
    return this.userService.isService;
  }


  isPilomatDev(): boolean {
    if (environment.onecontrol.serverFolder == "pilomatdev") {
      return true;
    } else {
      return false;
    }
  }

  checkIfNumber(event: any) {
    return event.charCode >= 48 && event.charCode <= 57
  }

  saveDeviceDetails() {
    this.loader.showLoading();

    if (this.canBusEnabledStr == "true") {
      this.device.canBusEnabled = true;
    } else {
      this.device.canBusEnabled = false;
    }

    if (this.licensePlateEnabledStr == "true") {
      this.device.licensePlateEnabled = true;
    } else {
      this.device.licensePlateEnabled = false;
    }

    if (this.ioEthEnabledStr == "true") {
      this.device.ioEthEnabled = true;
    } else {
      this.device.ioEthEnabled = false;
    }

    if (this.badge1EnabledStr == "true") {
      this.device.badge1Enabled = true;
    } else {
      this.device.badge1Enabled = false;
    }

    if (this.badge2EnabledStr == "true") {
      this.device.badge2Enabled = true;
    } else {
      this.device.badge2Enabled = false;
    }

    if (this.pin1EnabledStr == "true") {
      this.device.pin1Enabled = true;
    } else {
      this.device.pin1Enabled = false;
    }

    if (this.pin2EnabledStr == "true") {
      this.device.pin2Enabled = true;
    } else {
      this.device.pin2Enabled = false;
    }

    if (this.phoneEnabledStr == "true") {
      this.device.phoneEnabled = true;
    } else {
      this.device.phoneEnabled = false;
    }

    if (this.remoteEnabledStr == "true") {
      this.device.remoteEnabled = true;
    } else {
      this.device.remoteEnabled = false;
    }

    if (this.appEnabledStr == "true") {
      this.device.appEnabled = true;
    } else {
      this.device.appEnabled = false;
    }
    
    if (this.watchdogEnabledStr == "true") {
      this.device.watchDogEnabled = true;
      this.device.watchDogTimeSec = this.watchDogTimeSecValue;
    } else {
      this.device.watchDogEnabled = false;
      this.device.watchDogTimeSec = 0;
    }

    if (this.deviceReference != "") {
      this.device.systemInfo.reference = this.deviceReference;
    }
    if (this.deviceAddress != "") {
      this.device.systemInfo.address = this.deviceAddress;
    }
    if (this.deviceCity != "") {
      this.device.systemInfo.city = this.deviceCity;
    }
    if (this.deviceCountry != "") {
      this.device.systemInfo.country = this.deviceCountry;
    }
    if (this.deviceRouterSerial != "") {
      this.device.routerSerial = this.deviceRouterSerial;
    }
    if (this.deviceSystemId != "") {
      this.device.systemId = this.deviceSystemId;
    }

    if (this.deviceOrderConfirmation != "") {
      this.device.orderConfirmation = this.deviceOrderConfirmation;
    }

    if (this.devicePhoneNumber != "") {
      this.device.phoneNumber = this.devicePhoneNumber;
    }

    if (this.deviceModel != "") {
      this.device.systemInfo.model = this.deviceModel;
    }

    // TODO
    // if (this.notes != "") {
    //   this.device.notes = this.notes;
    // }

    if (this.deviceInstallationDate) {
      if (!isNaN(this.deviceInstallationDate.getTime())) {
        this.device.bollardInstallationDate = DateHelper.formatDateRFC3339(this.deviceInstallationDate);

        this.deviceService.updateDeviceDetails(this.device, this.device.serial).subscribe(res => {
            this.deviceService.forceIoUpdate(this.device.serial).subscribe(res => {
              this.dialogRef.close();
            });
          this.dialogRef.close();
        }, err => {
          Log.debug(err);
          this.loader.showError();
        });

      } else {
        let message = $localize`:@@device_details_editor_no_date_inserted_error:Per salvare i dettagli del dispositivo é necessario impostarne la data di installazione`;
        let header = $localize`:@@device_details_editor_warning:Attenzione`;

        const scrollStrategy = this
          .overlay.scrollStrategies.reposition();

        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
          width: "500px",
          data: { message, header },
          scrollStrategy,
        });

        dialogRef.afterClosed().subscribe((response) => {
          // if (response) {

          // }
        });
      }
    } else {
      let message = $localize`:@@device_details_editor_invalid_date_inserted_error:La data inserita non é valida`;
      let header = $localize`:@@device_details_editor_warning:Attenzione`;

      const scrollStrategy = this
        .overlay.scrollStrategies.reposition();

      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        width: "500px",
        data: { message, header },
        scrollStrategy,
      });

      dialogRef.afterClosed().subscribe((response) => {
        if (response) {

        }
      });
    }

  }
}
